<template>
  <component :is="type"
    :text="$i18n.locale.toUpperCase()" exact>
    <b-dropdown-item v-for="lang in activeLanguages" :key="lang.key" @click="setLang(lang.key)">
      <div class="d-flex">
        <span> {{ lang.key.toUpperCase() }}</span>
      </div>
    </b-dropdown-item>
  </component>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';
import { loadLang } from '@/_translate';

export default {
  mounted() {
    this.getData();
  },
  props: {
    type: {
      type: String,
      default: 'b-dropdown'
    },
  },
  computed: {
    ...mapGetters('Languages', [
      'activeLanguages'
    ]),
  },
  methods: {
    ...mapActions('Languages', {
      getData: VT.LANGUAGES_CLASSIFICATOR
    }),
    setLang: loadLang,
  }
};

</script>

<style scoped>
</style>
